export interface AlertConstants {
  invalidJWTMsg: string;
  invalidSessionMsg: string;
  invalidJWTCode: number;
  invalidSessionCode: number;
}

export enum ActionType {
  OPEN_ALERT = "OPEN_ALERT",
  CLOSE_ALERT = "CLOSE_ALERT",
}

export interface OpenAlertAction {
  type: ActionType.OPEN_ALERT;
  payload: Object;
}

export interface CloseAlertAction {
  type: ActionType.CLOSE_ALERT;
  payload: Object;
}

export type Action = OpenAlertAction | CloseAlertAction;

export interface ReducerState {
  show: boolean;
  msg: string;
}
